import posthog from "posthog-js";
import { PUBLIC_ENV } from "@/config/publicEnv";

let initialized = false;

/**
 * Initialises PostHog from runtime configuration.
 *
 * Must be called AFTER `loadPublicEnv()` resolves — the keys now come from
 * GET /api/config rather than from bundle literals, so initialising at module import
 * time (as this file used to) would run with empty values.
 *
 * No-ops when no key is configured, which is the correct behaviour for a local
 * environment without PostHog set up.
 */
export function initPostHog(): void {
  if (initialized) return;

  if (!PUBLIC_ENV.POSTHOG_KEY) {
    console.warn("PostHog key not configured — product analytics disabled.");
    return;
  }

  if (!PUBLIC_ENV.POSTHOG_HOST) {
    console.warn("PostHog host not configured — product analytics disabled.");
    return;
  }

  posthog.init(PUBLIC_ENV.POSTHOG_KEY, {
    api_host: PUBLIC_ENV.POSTHOG_HOST,
    capture_pageview: false,
    person_profiles: "identified_only",
    // Privacy-first session replay: production pages show recipient PII
    // (names, emails, addresses), so mask ALL inputs and ALL on-screen text.
    // Stripe card fields live in a cross-origin iframe, which replay does not
    // record, so card data is never captured. Replays still show layout,
    // clicks, navigation and errors — enough to see where users get stuck.
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
    },
  });

  initialized = true;
}

export default posthog;
